import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { Box, SxProps, Theme } from "@mui/material";

export const Loader = () => {
  const rectangular: SxProps<Theme> = {
    borderRadius: "7px 7px 0px 0px",
    marginBottom: 2,
  };

  return (
    <Stack spacing={1}>
      <Skeleton
        variant="rectangular"
        width={"100%"}
        height={200}
        sx={rectangular}
      />
      <Skeleton
        variant="rectangular"
        width={"100%"}
        height={200}
        sx={rectangular}
      />
      <Box
        sx={{
          marginTop: 2,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <Skeleton
          variant="rectangular"
          width={"15%"}
          height={30}
          sx={{ borderRadius: (theme) => theme.radius.medium }}
        />
      </Box>
    </Stack>
  );
};
